// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./src/vendors/js/remodal.js");
__webpack_require__("./src/vendors/css/remodal/remodal.css");
var __webpack_exports__ = __webpack_require__("./src/vendors/css/remodal/remodal-default-theme.css");
